import { request } from "../utils/request.js"

export const enumByName = (name, args) => request({
    url: 'enum/' + name,
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_UserTypeEnum = (args) => request({
    url: 'enum/UserTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityProductionStatusEnum = (args) => request({
    url: 'enum/CommodityProductionStatusEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_SupplierBalanceDetailChangeTypeEnum = (args) => request({
    url: 'enum/SupplierBalanceDetailChangeTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CustomerTypeEnum = (args) => request({
    url: 'enum/CustomerTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CustomerGroupEnum = (args) => request({
    url: 'enum/CustomerGroupEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CustomerBalanceDetailChangeTypeEnum = (args) => request({
    url: 'enum/CustomerBalanceDetailChangeTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

// export const enum_CustomerFollowUpStatusEnum = (args) => request({
//     url: 'enum/CustomerFollowUpStatusEnum',
//     method: 'GET',
//     showFailMessage: true,
//     ...args
// })

// export const enum_CustomerFollowUpDetailTypeEnum = (args) => request({
//     url: 'enum/CustomerFollowUpDetailTypeEnum',
//     method: 'GET',
//     showFailMessage: true,
//     ...args
// })

// export const enum_CustomerPoolSourceEnum = (args) => request({
//     url: 'enum/CustomerPoolSourceEnum',
//     method: 'GET',
//     showFailMessage: true,
//     ...args
// })

export const enum_OrderApprovalStatusEnum = (args) => request({
    url: 'enum/OrderApprovalStatusEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundCollectProgressEnum = (args) => request({
    url: 'enum/FundCollectProgressEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityOutputProgressEnum = (args) => request({
    url: 'enum/CommodityOutputProgressEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundPayProgressEnum = (args) => request({
    url: 'enum/FundPayProgressEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityInputProgressEnum = (args) => request({
    url: 'enum/CommodityInputProgressEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityOutputOrderTypeEnum = (args) => request({
    url: 'enum/CommodityOutputOrderTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityDeliverStatusEnum = (args) => request({
    url: 'enum/CommodityDeliverStatusEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityInputOrderTypeEnum = (args) => request({
    url: 'enum/CommodityInputOrderTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundCollectOrderTypeEnum = (args) => request({
    url: 'enum/FundCollectOrderTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundPayOrderTypeEnum = (args) => request({
    url: 'enum/FundPayOrderTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundAccountTypeEnum = (args) => request({
    url: 'enum/FundAccountTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_FundAccountDetailTypeEnum = (args) => request({
    url: 'enum/FundAccountDetailTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_CommodityQuantityDetailChangeTypeEnum = (args) => request({
    url: 'enum/CommodityQuantityDetailChangeTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_SysMenuTypeEnum = (args) => request({
    url: 'enum/SysMenuTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_ExtFieldEntityTypeEnum = (args) => request({
    url: 'enum/ExtFieldEntityTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const enum_ExtFieldTypeEnum = (args) => request({
    url: 'enum/ExtFieldTypeEnum',
    method: 'GET',
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/enum.js